<template>
<div class="chapter">
<div class="inner_page">
<p class="mattertitle"><span class="bold">Additional Praise for</span></p>
<p class="mattertitle"><span class="bolditalic">The Black Book of Outsourcing</span></p>
<p class="quotepara">“Oracle-On-Demand (formerly Oracle Outsourcing) is the future of how we will develop, deliver and support technology, a service that eliminates the challenge of managing IT. <em class="italic">The Black Book of Outsourcing</em> captures how to get outsourcing results and provides invaluable advice for leaders who are trying to drive tighter execution within their organizations.”</p>
<p class="quotesource">Juergen Rottler</p>
<p class="quotesource">Executive Vice President</p>
<p class="quotesource">Oracle Corporation</p>
<p class="quotepara">“The code for outsourcing management has been broken and the secrets for success are here in this book. <em class="italic">The Black Book of Outsourcing</em> has it all. This book will surely be a classic.”</p>
<p class="quotesource">John Steele</p>
<p class="quotesource">Group Director</p>
<p class="quotesource">British Telecom/Yahoo</p>
<p class="quotepara">“Brown &amp; Wilson deliver on the best, most innovative, new practices all aimed at helping one and all survive, manage, and lead in this new economy.”</p>
<p class="quotesource">Joann Martin</p>
<p class="quotesource">Vice President</p>
<p class="quotesource">Pitney Bowes Management Services</p>
<p class="quotepara">“As more and more companies embrace offshoring solutions, <em class="italic">The Black Book of Outsourcing</em> should become a useful aid to the business person looking to navigate the industry with success.”</p>
<p class="quotesource">Raj Patil</p>
<p class="quotesource">Senior Vice President</p>
<p class="quotesource">Marketing and Sales Strategy</p>
<p class="quotesource">MphasiS Corporation</p>
<p class="quotepara">“Outsourcing is a business imperative in our interconnected and interdependent world. Organizations who successfully leverage its power create value for their stakeholders. This book will help you master that destiny.”</p>
<p class="quotesource">Shiv Nadar</p>
<p class="quotesource">Founder and Chief Executive Officer</p>
<p class="quotesource">HCL Technologies</p>
<p class="quotepara">“The exceptional concepts in this book enabled us to build more products and increase services to clients, all while reducing costs.”</p>
<p class="quotesource">Mark A. Stiffler</p>
<p class="quotesource">President and CEO</p>
<p class="quotesource">Synygy Inc.</p>
<p class="quotepara">Business leaders hoping to understand the concerns, challenges and motivating forcues behind the subject of global sourcing will find <em class="italic">The Black Book of Outsourcing</em> to be an extremely valuable and important tool.”</p>
<p class="quotesource">Dilip R. Vellodi</p>
<p class="quotesource">Chief Executive Officer</p>
<p class="quotesource">Sutherland Global Services</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter.vue?69865cae